import { render } from "./OutgoingItems.vue?vue&type=template&id=f56e8f44&scoped=true"
import script from "./OutgoingItems.vue?vue&type=script&lang=js"
export * from "./OutgoingItems.vue?vue&type=script&lang=js"

import "./OutgoingItems.vue?vue&type=style&index=0&id=f56e8f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56e8f44"]])

export default __exports__